import { render, staticRenderFns } from "./oriporeman.vue?vue&type=template&id=317adbeb&scoped=true&"
import script from "./oriporeman.vue?vue&type=script&lang=js&"
export * from "./oriporeman.vue?vue&type=script&lang=js&"
import style0 from "./oriporeman.vue?vue&type=style&index=0&id=317adbeb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317adbeb",
  null
  
)

export default component.exports